export const SOCIAL_NETWORK_KEY_TO_TYPE_ID = Object.freeze({
  linkedin: '1',
  twitter: '2',
  tiktok: '3',
  instagram: '4',
  facebook: '5',
});

export const SOCIAL_NETWORK_TYPE_ID_TO_KEY = Object.freeze(
  Object.entries(SOCIAL_NETWORK_KEY_TO_TYPE_ID).reduce((acc, [key, value]) => {
    acc[value] = key;
    return acc;
  }, {})
);

const NETWORK_ALIASES = Object.freeze({
  x: 'twitter',
  'twitter/x': 'twitter',
  'twitter-x': 'twitter',
});

export const normalizeNetworkKey = (value) => {
  if (value === null || value === undefined) {
    return null;
  }

  if (typeof value === 'number') {
    return SOCIAL_NETWORK_TYPE_ID_TO_KEY[String(value)] || null;
  }

  const normalizedValue = String(value).trim().toLowerCase();
  if (!normalizedValue) {
    return null;
  }

  if (SOCIAL_NETWORK_TYPE_ID_TO_KEY[normalizedValue]) {
    return SOCIAL_NETWORK_TYPE_ID_TO_KEY[normalizedValue];
  }

  const aliasValue = NETWORK_ALIASES[normalizedValue] || normalizedValue;
  return SOCIAL_NETWORK_KEY_TO_TYPE_ID[aliasValue] ? aliasValue : null;
};

export const normalizeNetworkList = (values = []) => {
  if (!Array.isArray(values)) {
    return [];
  }

  const deduplicated = [];
  for (const value of values) {
    const normalized = normalizeNetworkKey(value);
    if (!normalized) {
      continue;
    }

    if (!deduplicated.includes(normalized)) {
      deduplicated.push(normalized);
    }
  }

  return deduplicated;
};

export const mapNetworkKeysToTypeIds = (values = []) =>
  normalizeNetworkList(values)
    .map((networkKey) => SOCIAL_NETWORK_KEY_TO_TYPE_ID[networkKey])
    .filter(Boolean);

export const mapNetworkTypeIdsToKeys = (values = []) => normalizeNetworkList(values);

